import { TextField } from '@sunwebgroup/uds-ui/fields/text-field'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import {
  getErrorMessage,
} from '@/scopes/checkout/groups/components/services/RoomSelection/Sheet/FormFields/getErrorMessages'

export function PinCodeFormField({ helpText }: { helpText?: string }) {
  const { formState, register, watch } = useFormContext()
  const { errors } = formState
  const watchedAssignationMethod = watch('assignationMethod')
  const intl = useIntl()

  const errorMessage = getErrorMessage(
    'pinCode',
    errors,
    {
      requiredErrorMessage: intl.formatMessage({ id: 'groups_checkout_steps_room_selection_pin_code_required_error_message' }),
      isFourDigitsErrorMessage: intl.formatMessage({ id: 'groups_checkout_steps_room_selection_pin_code_four_digits_error_message' }),
      isNumericErrorMessage: intl.formatMessage({ id: 'groups_checkout_steps_room_selection_pin_code_numeric_error_message' }),
      backendInvalidErrorMessage: intl.formatMessage({ id: 'groups_checkout_steps_room_selection_pin_code_invalid_error_message' }),
    },
  )

  return (
    <TextField
      label={intl.formatMessage({ id: 'groups_checkout_steps_room_selection_pin_code_field_label' })}
      feedbackText={errorMessage}
      status={errorMessage ? 'error' : 'default'}
      inputProps={register('pinCode', {
        required: watchedAssignationMethod === 'specific',
        validate: {
          isNumeric: value => /^\d+$/.test(value),
          isFourDigits: value => /^\d{4}$/.test(value),
        },
      })}
      helpText={helpText}
      name="pinCode"
    />
  )
}
